import React from "react";
import classNames from "classnames";


export default class AppearanceSwitch extends React.PureComponent {
  constructor () {
    super();
    this.state = {};
    this.switchMode = this.switchMode.bind(this);
    this.postAppearance = this.postAppearance.bind(this);
  }

  postAppearance (appearance) {
    this.switchMode(appearance);
    const formData = new FormData();
    formData.append("appearance", appearance);
    fetch('/wp-json/she-rest-api/setSiteAppearance', {method: "POST", body: formData})
      .then(response => response.json())
      .then(({appearance}) => { this.switchMode(appearance); });
  }

  switchMode (appearance) {
    const bodyClassList = document.body.classList;
    if (appearance === 'dark') {
      bodyClassList.remove('light-mode');
      bodyClassList.add('dark-mode');
    } else if (appearance === 'light') {
      bodyClassList.remove('dark-mode');
      bodyClassList.add('light-mode');
    }
  }

  itemClass (appearance) {
    return (
      <div
        className={classNames(
          "menu-appearance__item",
          `menu-appearance__item--${appearance}`
        )}
        onClick={() => this.postAppearance(appearance)}
      >{appearance}</div>
    );
  }

  render () {
    return (
      <div className="menu-appearance">
        <div className="menu-appearance__title">mode</div>
        <div className="menu-appearance__switch">{this.itemClass("light")}{this.itemClass("dark")}</div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Menu/AppearanceSwitch.js